import { useFormikContext } from 'formik';

import { FormSection } from '@@/form-components/FormSection';
import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

import { FormValues } from '../types';

interface Props {
  releaseName: string;
}

export function DeploymentSection({ releaseName }: Props) {
  const { values, setFieldValue, errors } = useFormikContext<FormValues>();

  return (
    <FormSection title="Deploy to">
      <FormControl
        label="Release name"
        errors={errors.helmReleaseName}
        required
        tooltip="Automatically generated based on edge stack name (edge-<name>)"
      >
        <Input
          value={releaseName}
          onChange={() => {}} // No-op, read-only
          placeholder="e.g. edge-myapp"
          data-cy="helm-release-name-input"
          readOnly
          disabled
        />
      </FormControl>

      <FormControl
        label="Namespace"
        errors={errors.helmNamespace}
        required
        tooltip="Kubernetes namespace to deploy the Helm chart into"
      >
        <Input
          value={values.helmNamespace || ''}
          onChange={(e) => setFieldValue('helmNamespace', e.target.value)}
          placeholder="e.g. default"
          data-cy="helm-namespace-input"
        />
      </FormControl>
    </FormSection>
  );
}
